module.exports = __webpack_public_path__ + "static/media/01.c72e3b8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/singapore/01.jpg
// module id = 514
// module chunks = 0